export default "__VITE_ASSET__CuWedc2Q__"